<div *ngIf="loading == true" class="spinner">
  <div class="sk-spinner sk-spinner-pulse"></div>
</div>
<app-session-form (onAfterSave)="afterSave($event)"></app-session-form>
